import { Component } from 'react'
import {JSONFetcher, gaEvent} from 'shared'
import {Modal} from 'shared/components/modal'

export class SubscribeModal extends Component {
  render() {
    return <Modal
      show={this.props.show}
      onHide={this.props.onHide}
      id='project-newsletter-subscription-modal'
      content={<SubscriptionForm {...this.props} onHide={this.props.onHide} />}
      header={I18n.t('projects.show.stats.subscribe_modal_headline')}
    />
  }
}

class SubscriptionForm extends Component {
  state = {
    email:               '',
    projectNewsletter:   true,
    platformNewsletter:  true,
    submitted:           false,
    error:               false,
    showModal:           false
  }

  handleSubmit = (event) => {
    if (this.state.platformNewsletter)
      gaEvent('engagement', 'submit subscribe_platform_newsletter_form')
    if (this.state.projectNewsletter)
      gaEvent('engagement', 'submit subscribe_project_newsletter_form')
    event.preventDefault()
    JSONFetcher.post({
      url: this.props.url,
      jsonObject: {
        email:               this.state.email,
        platform_newsletter: this.state.platformNewsletter,
        project_newsletter:  this.state.projectNewsletter
      },
      success: (response) => {
        if(response.error) {
          this.setState({error: response.error})
          gaEvent('error', 'field: newsletter_email', `error: ${response.error}`, null, true)
        } else {
          this.setState({submitted: true})
        }
      }
    })

  }

  closeModal = () => {
    this.setState({submitted: false, error: false, email: '', showModal: false})
  }

  render() {
    if(this.state.submitted) {
      return <div>
          <p>{I18n.t('projects.show.stats.subscribe_modal_thank_you')}</p>
          <button className='btn btn-primary btn-large' onClick={this.props.onHide}>
            {I18n.t('projects.show.stats.subscribe_modal_close_button')}
          </button>
        </div>
    } else {
      return <div>
        <form className='simple_form' onSubmit={this.handleSubmit}>
          <div className='form-group'>
            <label className='control-label' htmlFor='mailing_newsletter_opt_in_email'>
              <abbr title="required">*</abbr> E-Mail
            </label>
            <input
              className={`form-control ${this.state.error ? 'field-with-error' : '' }`}
              id='mailing_newsletter_opt_in_email'
              type='text'
              value={this.state.email}
              onChange={(event) => this.setState({ email: event.target.value })}
            />
            { this.state.error && <div className='help-inline'>{this.state.error}</div> }
          </div>

          <div className='form-group'>
            <div className='checkbox'>
              <label>
                <input
                  type='checkbox'
                  checked={this.state.projectNewsletter}
                  onChange={(event) => this.setState({ projectNewsletter: event.target.checked })}
                /> <span dangerouslySetInnerHTML={{ __html: I18n.t('projects.show.stats.subscription_project_label', { project_name: this.props.project.title })}} />
              </label>
            </div>
          </div>

          <div className='form-group'>
            <div className='checkbox'>
              <label>
                <input
                  type='checkbox'
                  checked={this.state.platformNewsletter}
                  onChange={(event) => this.setState({ platformNewsletter: event.target.checked })}
                /> {I18n.t('projects.show.stats.subscription_platform_label')}
              </label>
            </div>
          </div>

          <div className='form-actions text-center'>
            <input type='submit' value={I18n.t('projects.show.stats.subscription_modal_button')} className='btn btn-primary btn-large' />
          </div>

          <div className='text-muted'
            dangerouslySetInnerHTML={{ __html: I18n.t('projects.show.stats.subscription_modal_disclaimer') }}
          />
        </form>
      </div>
    }
  }
}
